module.exports = __webpack_public_path__ + "static/media/bpi.190e4043.svg";